$(function() {
	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = timestamp => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min(
				(timestamp - startTimestamp) / duration,
				1
			);
			if (obj)
				obj.innerText = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	let obj = document.getElementById('pl_counter-project1');
	if (obj) animateValue(obj, 0, obj.dataset.numbercount, 4000);

	obj = document.getElementById('pl_counter-project2');
	if (obj) animateValue(obj, 0, obj.dataset.numbercount, 4000);
});

$(function() {
	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = timestamp => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min(
				(timestamp - startTimestamp) / duration,
				1
			);
			if (obj)
				obj.innerText = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}

	const contadorObserver = new IntersectionObserver(function(
		entries,
		observer
	) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				const obj = entry.target;
				const start = 0;
				const end = parseInt(obj.dataset.numbercount);
				const duration = 4000;

				animateValue(obj, start, end, duration);

				observer.unobserve(obj);
			}
		});
	});

	const contadorElementos = document.querySelectorAll('[data-numbercount]');

	contadorElementos.forEach(function(obj) {
		contadorObserver.observe(obj);
	});
});
